import { APP_PATHS, profilePath } from '@/app/routes/paths';

export interface PushDeepLinkPayload {
  type?: string;
  url?: string | null;
  objectDataId?: number | string;
  whoFiredUserBasicDetail?: { username?: string };
}

const PROFILE_TYPES = new Set(['JoinBoard', 'BoardCreate', 'FollowUser', 'AcceptFollowRequest']);
const CHAT_TYPES = new Set(['Chat', 'GroupChat', 'Message', 'ChatMessage']);

function safeExplicitUrl(value: string | null | undefined): string | null {
  if (!value) return null;
  if (value.startsWith('/') && !value.startsWith('//')) return value;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.toString() : null;
  } catch {
    return null;
  }
}

/** Resolve MyU push destinations using the notification types in iOS AppDelegate. */
export function resolvePushDeepLink(
  payload: PushDeepLinkPayload,
  fallback?: string | null,
): string {
  const explicit = safeExplicitUrl(fallback) ?? safeExplicitUrl(payload.url);
  if (explicit) return explicit;

  const type = payload.type ?? '';
  const objectId = payload.objectDataId == null ? '' : String(payload.objectDataId).trim();

  if (CHAT_TYPES.has(type)) {
    const query = objectId ? `?conversationId=${encodeURIComponent(objectId)}` : '';
    return `${APP_PATHS.messages}${query}`;
  }

  if (type === 'CMS') return APP_PATHS.notifications;
  if (type === 'DYNAMIC_REPORT_SUBMIT') return APP_PATHS.reportCards;

  if (PROFILE_TYPES.has(type)) {
    const username = payload.whoFiredUserBasicDetail?.username?.trim();
    return username ? profilePath(username) : APP_PATHS.notifications;
  }

  // Post, assignment, event, class-request, follow-request, and chain
  // notifications land on the notification screen, whose API-backed rows
  // contain the additional identifiers needed for their detail view.
  return APP_PATHS.notifications;
}
